import ccureApi from "@/services/api.ccure.service";
import { ServerType } from "@/constants/ServerType";
import { PostDoorActionLogPayload } from "@/store/ccure/types";
import store from "@/store/";

type PostDoorActionLoggingReference = (payload: PostDoorActionLogPayload) => Promise<void>;

type PostDoorActionFeatureFlagReference = () => void;

type PostDoorActionAction = {
	[key in ServerType]?: PostDoorActionLoggingReference;
};

type PostDoorActionLoggingEnabledByIntegration = {
    [key in ServerType]?: PostDoorActionFeatureFlagReference;
};

// Dictionary that maps integrations with their corresponding API call, can be extended for further integrations
const postDoorActionAction: PostDoorActionAction = {
	[ServerType.CCure]: ccureApi.addLogEntryForDoorAction.bind(ccureApi)
};

// Dictionary that maps integrations with their corresponding feature flag, can be extended for further integrations
const postDoorActionLoggingEnabledByIntegration: PostDoorActionLoggingEnabledByIntegration = {
    [ServerType.CCure]: () => store?.state.featuresList.Integration.CCure.UI.LogDoorAction,
};

/**
 * Adds a journal log for a door from a specific integration
 *
 * @remarks
 * This method is generic and can support multiple integrations
 *
 * @param actionType - The action type carried out e.g pulse
 * @param deviceId - The Id of device (door) that had action carried out
 * @param serverType - The server type the door belongs to
 *
 */
export const processLoggingPostDoorAction = async (
	actionType: string,
    deviceId: number,
    serverType: number
): Promise<void> => {
	const postForceRestoreActionToPerform: PostDoorActionLoggingReference = postDoorActionAction[serverType];

    const featureFlagEnabled: boolean = postDoorActionLoggingEnabledByIntegration[serverType] ?
    postDoorActionLoggingEnabledByIntegration[serverType]() : false;

	if (postForceRestoreActionToPerform && featureFlagEnabled) {
		await postForceRestoreActionToPerform({
            doorAction: actionType,
            deviceId
        });
	}
};